var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.9 48.6",
    style: {
      enableBackground: "new 0 0 31.9 48.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E98832;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    className: "st0",
    d: "M28.5,48.6h-25C1.6,48.6,0,47,0,45.1V3.5C0,1.6,1.6,0,3.5,0h25c1.9,0,3.5,1.6,3.5,3.5v41.6 C31.9,47,30.4,48.6,28.5,48.6z M3.5,1.4c-1.1,0-2.1,0.9-2.1,2.1v41.6c0,1.1,0.9,2.1,2.1,2.1l0,0h25c1.1,0,2.1-0.9,2.1-2.1l0,0V3.5 c0-1.1-0.9-2.1-2.1-2.1l0,0L3.5,1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    className: "st0",
    d: "M0.7,41.6h30.5V43H0.7V41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    className: "st0",
    d: "M13.2,44.4h5.6v1.4h-5.6V44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    className: "st0",
    d: "M0.7,5.6h30.5v1.4H0.7V5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    className: "st0",
    d: "M11.8,2.8h8.3v1.4h-8.3V2.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOrange);
export default __webpack_public_path__ + "static/media/phone_orange.6513a88a12f50ff2efd828dad8cd7db7.svg";
export { ForwardRef as ReactComponent };